import React, { useContext } from "react"

import { ContactAvatar } from "@components/common"
import { NewTeeupPageContext } from "@contexts/NewTeeupPageContext"

import { ParticipantAvatarWrapper } from "../../ParticipantAvatarWrapper"
import { BlockWrapper } from "../newTeeupSettingsStyles"

import {
  Wrapper,
  Title,
  List,
  ListItem,
  OrganiserName,
} from "./organizersStyles"

export const Organizers = () => {
  const { teeup } = useContext(NewTeeupPageContext)

  return (
    <BlockWrapper>
      <Wrapper>
        <Title>Organizer(s)</Title>

        <List>
          {/* FIX 1 sweep (2026-07-04, same class as CREATE-AI-POLISH's DropDown guard,
              0ccf41f0): `teeup.organisers` can be absent on a not-yet-enriched teeup. This
              modal is user-triggered from the gear icon after the page has loaded, so low
              risk, but the guard is cheap and closes the whole class of bug. */}
          {(teeup.organisers || []).map(organizer => (
            <ListItem key={organizer.id}>
              <ParticipantAvatarWrapper isOrganiser>
                <ContactAvatar
                  src={organizer.avatar}
                  text={organizer.name}
                  size={48}
                />
              </ParticipantAvatarWrapper>
              <OrganiserName>@{organizer.username}</OrganiserName>
            </ListItem>
          ))}
        </List>
      </Wrapper>
    </BlockWrapper>
  )
}
